import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    settings: [],
    loaded: false
  }
};
const aiOCRSlice = createSlice({
  name: "aiOCRInfo",
  initialState,
  reducers: {
    getAIOCRSettings: (state, action) => {
      state.value = {
        settings: action.payload,
        loaded: true
      };
    }
  }
});
export const { getAIOCRSettings } = aiOCRSlice.actions;
export default aiOCRSlice.reducer;
